import { lazy } from "react"

const PinPage$$__react__lazy__component = lazy(() => 
    import("./PinPage__original__module.mjs")
        .then(module => module.get_$$PinPage$$PinPage$$react__component$$358x2i6fdoot6())
        .then(component => ({ default: component }))
)

export const get_$$PinPage$$PinPage$$react__component$$358x2i6fdoot6 = () => PinPage$$__react__lazy__component